export interface Partner {
  id: number;
  name: string;
  description: string;
  type: string;
  image: string;
  website: string;
}

export const partners: Partner[] = [
  {
    id: 1,
    name: "École de Musique Arc-en-Ciel",
    description: "École de musique proposant des cours adaptés aux enfants de tous âges et de tous niveaux.",
    type: "Éducation Musicale",
    image: "/src/assets/images/partner1.jpg",
    website: "https://www.exemple-ecole-musique.fr"
  },
  {
    id: 2,
    name: "Centre Culturel Jeunesse",
    description: "Centre culturel dédié aux enfants proposant des ateliers créatifs, des spectacles et des expositions.",
    type: "Centre Culturel",
    image: "/src/assets/images/activity1.jpg",
    website: "https://www.exemple-centre-culturel.fr"
  },
  {
    id: 3,
    name: "Association Nature & Découvertes",
    description: "Organisation proposant des activités de plein air et des ateliers de découverte de la nature.",
    type: "Environnement",
    image: "/src/assets/images/activity3.jpg",
    website: "https://www.exemple-nature-decouvertes.fr"
  },
  {
    id: 4,
    name: "Compagnie Théâtrale Les Petits Comédiens",
    description: "Troupe de théâtre spécialisée dans les spectacles pour enfants et les ateliers d'expression artistique.",
    type: "Théâtre",
    image: "/src/assets/images/activity2.jpg",
    website: "https://www.exemple-compagnie-theatre.fr"
  }
];
